import { theme } from "@op-str/op-component-library"
import React from "react"
import styled from "styled-components"
import { LargePageContent } from "../LargePageContent"

export type HelpHeaderProps = {
  subtitle?: string
  title?: string
}

export const HelpHeader = (props: HelpHeaderProps) => {
  const { subtitle, title } = props

  return (
    <Root>
      {title && <Title>{title}</Title>} {subtitle && <Title>{subtitle}</Title>}
    </Root>
  )
}

const Root = styled(LargePageContent)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.m};
  margin: ${theme.spacing.xl} auto;
`

const Title = styled.span`
  font-size: 48px;
  line-height: 62.4px;
  font-family: ${theme.font.bold};
`
